import React from "react";
import { Link, useLocation } from "react-router-dom";

const CRUMBS = {
  "/custom-homes": [{ n: "Construction", to: "/construction" }, { n: "Custom Homes" }],
  "/renovations": [{ n: "Construction", to: "/construction" }, { n: "Renovations & Additions" }],
  "/kitchen-and-bath": [{ n: "Construction", to: "/construction" }, { n: "Kitchen & Bath" }],
  "/commercial-construction": [{ n: "Construction", to: "/construction" }, { n: "Commercial" }],
  "/construction": [{ n: "Construction" }],
  "/disaster-recovery": [{ n: "Disaster Recovery", to: "/federal-services" }, { n: "Disaster Recovery & FEMA PA" }],
  "/federal": [{ n: "Disaster Recovery", to: "/federal-services" }, { n: "Federal Construction & Teaming" }],
  "/federal-services": [{ n: "Disaster Recovery" }],
  "/projects/north-tampa-custom-home": [{ n: "Our Work", to: "/projects" }, { n: "North Tampa Custom Home" }],
  "/expert-witness": [{ n: "Expert Witness" }],
  "/projects": [{ n: "Our Work" }],
  "/about": [{ n: "About" }],
  "/team": [{ n: "About", to: "/about" }, { n: "Leadership & Team" }],
  "/work-with-us": [{ n: "About", to: "/about" }, { n: "Work With Us" }],
  "/faq": [{ n: "About", to: "/about" }, { n: "FAQ" }],
  "/contact": [{ n: "Contact" }],
  "/privacy": [{ n: "Privacy" }],
  "/terms": [{ n: "Terms" }],
};

export default function Breadcrumbs() {
  const { pathname } = useLocation();
  if (pathname === "/") return null;

  let items = CRUMBS[pathname];
  if (!items && pathname.startsWith("/projects/")) {
    items = [{ n: "Our Work", to: "/projects" }, { n: "Project" }];
  }
  if (!items) return null;

  return (
    <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="bg-cream-light border-b border-ink/5 mt-20">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-3 text-[11px] tracking-[0.1em] uppercase text-ink/60">
        <Link to="/" className="hover:text-copper">Home</Link>
        {items.map((it, i) => (
          <React.Fragment key={i}>
            <span className="mx-2">/</span>
            {it.to ? <Link to={it.to} className="hover:text-copper">{it.n}</Link> : <span className="text-ink/85">{it.n}</span>}
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
}
